import Vue from "vue";
import VueRouter from "vue-router";
import index from "@/views/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: index,
    redirect: "/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/index"),
        name: "Index",
        meta: { title: "欢迎来到毛三仙的博客" },
      },
    ],
  },

  {
    path: "/about",
    name: "about",
    meta: {
      title: "about",
    },
    component: () =>
      import(/* webpackChunkName: "workExperience" */ "@/views/about.vue"),
  },

  {
    path: "/workExperience",
    name: "workExperience",
    meta: {
      title: "工作经历",
    },
    component: () =>
      import(
        /* webpackChunkName: "workExperience" */ "@/views/menuPage/workExperience.vue"
      ),
  },
  {
    path: "/educationExperience",
    name: "educationExperience",
    meta: {
      title: "教育经历",
    },
    component: () =>
      import(
        /* webpackChunkName: "educationExperience" */ "@/views/menuPage/educationExperience.vue"
      ),
  },
  {
    path: "/openProjects",
    name: "openProjects",
    meta: {
      title: "开源项目",
    },
    component: () =>
      import(
        /* webpackChunkName: "openProjects" */ "@/views/menuPage/openProjects.vue"
      ),
  },
  {
    path: "/friendlyLinks",
    name: "friendlyLinks",
    meta: {
      title: "友情链接",
    },
    component: () =>
      import(
        /* webpackChunkName: "friendlyLinks" */ "@/views/menuPage/friendlyLinks.vue"
      ),
  },
  {
    path: "/contactMe",
    name: "contactMe",
    meta: {
      title: "联系我",
    },
    component: () =>
      import(
        /* webpackChunkName: "contactMe" */ "@/views/menuPage/contactMe.vue"
      ),
  },
  {
    path: "/future",
    redirect: "/annualSummarize",
    name: "annualSummarize",
    meta: {
      title: "年度总结",
    },
    component: () =>
      import(
        /* webpackChunkName: "annualSummarize" */ "@/views/menuPage/future/index.vue"
      ),
    // component: Main,
    children: [
      {
        path: "/annualSummarize",
        name: "annualSummarize",
        meta: {
          title: "年度总结",
        },
        component: () =>
          import(
            /* webpackChunkName: "annualSummarize" */ "@/views/menuPage/future/annualSummarize.vue"
          ),
      },
      {
        path: "/annualPlan",
        name: "annualPlan",
        meta: {
          title: "年度计划",
        },
        component: () =>
          import(
            /* webpackChunkName: "annualPlan" */ "@/views/menuPage/future/annualPlan.vue"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || "毛三仙的博客";
});

export default router;
